import React from "react";

import { useStores } from "@/store";

// NOTE:
// Head-bar / browse filter shared state is now managed by MobX (HeaderStore).
// This hook is kept for API compatibility with existing components.
export function useFilterContext() {
  const { HeaderStore } = useStores();
  return HeaderStore;
}

// No-op provider kept only for backwards compatibility.
// The app should no longer mount a provider for this.
export function FilterProvider({ children }) {
  return <>{children}</>;
}
